// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"CheckDetails_detailsContainer__qLoIe"};